module.exports = __webpack_public_path__ + "media/top/main_visual_working-f6e645dd.svg";